module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-standside-1100.d5d9eadf.svg";